export default __webpack_public_path__ + "static/media/herobg1.f6cb8627.jpg";